import { SwiperItem } from '.';
import { Component } from "../../helpers/compiler";

@Component({ className: 'js-swiper' })
export class SwiperComponent {
    constructor(element: HTMLElement) {
        const perview = Number.parseFloat(element.getAttribute('data-swiper-perview') || '1');
        const scale = (element.getAttribute('data-swiper-scale') === 'true');
        const vertical = (element.getAttribute('data-swiper-vertical') === 'true');
        const loop = (element.getAttribute('data-swiper-loop') === 'true');
        const mousewheel = (element.getAttribute('data-swiper-mousewheel') === 'false');
        const mousewheelTarget = (element.getAttribute('data-swiper-mousewheel-target')) || 'container';
        const spacing = Number.parseFloat(element.getAttribute('data-swiper-spacing') || '0');
        const nextBtn = element.getAttribute('data-swiper-next-btn') || '.swiper-button-next';
        const prevBtn = element.getAttribute('data-swiper-prev-btn') || '.swiper-button-prev';
        const autoplay = this.parseToBoolOrInt(element, 'data-swiper-autoplay');

        new SwiperItem(element, {
            slidesPerView: perview,
            scale: scale,
            spacing: spacing,
            autoplay: autoplay,
            vertical: vertical,
            loop: loop,
            mousewheel: !mousewheel,
            mousewheelTarget: mousewheelTarget,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn
            }
        })
    }

    private parseToBoolOrInt(el: HTMLElement, attr: string) {
        const val: string | null = el.getAttribute(attr);
        const parsedNum = Number.parseInt(val || 'false');
        return isNaN(parsedNum) ? val == 'true' : parsedNum
    }
}
